import React from "react";
import { FloatButton } from "antd";
import { useSandboxAI } from "./SandboxAIContext";
import SandboxIcon from "./SandboxIcon";

const SandboxAIFab: React.FC = () => {
  const { open, status, togglePanel } = useSandboxAI();
  const showDot = status === "working" && !open;

  return (
    <FloatButton
      className="sandbox-ai-fab"
      icon={<SandboxIcon />}
      tooltip="Sandbox AI"
      onClick={togglePanel}
      badge={showDot ? { dot: true } : undefined}
      // Same 50px circle and right edge as the Whistle AI FAB. styles.css sets the
      // vertical slot, because it depends on which buttons render below it.
      style={{ right: 25 }}
    />
  );
};

export default SandboxAIFab;
